const Condition = require('../condition')
const Action = require('../action')

class Rule {
  constructor(rule) {
    this.id = rule.id || rule._id
    this._id = this.id
    this.name = rule.name
    this.description = rule.description
    this.enabled = rule.enabled
    this.type = rule.type
    this.order = rule.order
    this.allConditions = rule.allConditions
    this.conditions = rule.conditions.map(c => new Condition(c))
    this.actions = rule.actions.map(a => ({
      id: a.id || a._id,
      _id: a.id,
      value: a.value,
      action: new Action(a.action)
    }))
  }

  validateConditions(obj) {
    const method = this.allConditions ? 'every' : 'some'
    return this.enabled && this.conditions[method](condition => condition.valid(obj))
  }
}

module.exports = Rule
